<template>
  <AdminLayout>
    <template #breadcrumb>
      <breadcrumb-link view="AdminPatientVerificationList" label="Patient Verifications" />
      <breadcrumb-link
        view="AdminPatientVerificationDetail"
        label="Result"
        :params="{ id: $route.params.id }"
        :active="true"
      />
    </template>
    <b-loading :active="loading" :is-full-page="false" />
    <PatientVerificationDetail
      v-if="verification"
      :verification="verification"
      :admin-mode="true"
    />
    <b-message v-if="error" type="is-danger" :closable="false">{{ error }}</b-message>
  </AdminLayout>
</template>
<script>
import request from '../../request';
import AdminLayout from '../../layouts/AdminLayout.vue';
import PatientVerificationDetail from '../../components/PatientVerificationDetail.vue';
export default {
  name: 'AdminPatientVerificationDetail',
  components: { AdminLayout, PatientVerificationDetail },
  data() {
    return { verification: null, loading: false, error: '' };
  },
  watch: {
    '$route.params.id': {
      immediate: true,
      async handler() {
        const id = this.$route.params.id;
        this.verification = null;
        this.loading = true;
        this.error = '';
        try {
          const resp = await request.get(`/admin/patient-verifications/${id}`);
          if (this.$route.params.id === id) this.verification = resp.data.patient_verification;
        } catch (err) {
          if (this.$route.params.id === id) this.error = 'Verification not found or unavailable.';
        } finally {
          if (this.$route.params.id === id) this.loading = false;
        }
      },
    },
  },
};
</script>
